import { useEffect, useState } from 'react';
import { usePrevious } from '@core/hooks/usePrevious';
import { discardWrapper, videoWrapperFactory } from '../videoWrapperFactory';
/**
 * @returns A video wrapper generated from the video data.
 */
export const useVideoWrapperFactory = (video, key, autoplay, muted, playsInline) => {
    const [wrapper, setWrapper] = useState();
    const [wrapperState, setWrapperState] = useState();
    const wrapperStatePrevious = usePrevious(wrapperState);
    useEffect(() => {
        if (video /* && wrapperStatePrevious !== wrapperState */) {
            videoWrapperFactory(video, { key, autoplay, muted, playsInline }).then(setWrapper);
        }
    }, [
        autoplay,
        key,
        muted,
        playsInline,
        video,
        wrapperState,
        wrapperStatePrevious,
    ]);
    useEffect(() => {
        return () => {
            discardWrapper(key);
        };
    }, [key]);
    useEffect(() => {
        if (wrapper) {
            return wrapper.onStateChange(setWrapperState);
        }
    }, [wrapper]);
    return wrapper;
};
